import React from 'react';
import { GoogleMapsProvider } from './context/GoogleMapsContext';
import { AboutUs, Testimonials, FindUs, Footer, Gallery, Header, Intro, SpecialMenu } from './container';
import { Navbar } from './components';
import './App.css';

const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || import.meta?.env?.VITE_GOOGLE_MAPS_API_KEY;
const libraries = ["places"];

const App = () => (
    <GoogleMapsProvider apiKey={apiKey} libraries={libraries}>
        <div>
            <Navbar />
            <Header />
            <AboutUs />
            <SpecialMenu />
            <Intro />
            <Testimonials />
            <Gallery />
            <FindUs />
            <Footer />
        </div>
    </GoogleMapsProvider>
);

export default App;
